import * as Dialog from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface ModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  children: ReactNode
  footer?: ReactNode
  className?: string
}

export function Modal({ open, onOpenChange, title, description, children, footer, className }: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-(--scrim) backdrop-blur-xs" />
        <div className="pointer-events-none fixed inset-0 z-50 grid place-items-center p-4">
          <Dialog.Content
            className={cn(
              'pointer-events-auto flex max-h-[86vh] w-[min(92vw,540px)] flex-col overflow-hidden rounded-card bg-surface shadow-pop animate-fade-in focus:outline-hidden',
              className,
            )}
          >
            <div className="flex items-start justify-between gap-4 border-b border-hairline px-5 py-4">
              <div className="min-w-0">
                <Dialog.Title className="text-base font-semibold text-ink">{title}</Dialog.Title>
                {description ? <Dialog.Description className="mt-0.5 text-sm text-ink-faint">{description}</Dialog.Description> : null}
              </div>
              <Dialog.Close className="btn-ghost h-8 w-8 shrink-0 p-0" aria-label="Sluiten">
                <X className="h-4 w-4" />
              </Dialog.Close>
            </div>
            <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">{children}</div>
            {footer ? <div className="flex items-center justify-end gap-2 border-t border-hairline px-5 py-3">{footer}</div> : null}
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
